<script setup lang="ts">
  import WButton from 'src/components/base/Button.vue';
  import AddressSearch from 'src/components/base/AddressSearch.vue';
  import WidgetIcon from 'src/components/base/WidgetIcon.vue';
  import { checkTheme, themeIcons } from 'src/utils/config';
  import { ILocationInfo } from 'src/utils/map';

  interface Props {
    editable?: boolean;
    loading?: boolean;
  }

  defineProps<Props>();

  const emit = defineEmits<{
    change: [ILocationInfo];
    close: [];
  }>();

  function onClose() {
    emit('close');
  }
  function locationChange(params: ILocationInfo) {
    emit('change', params);
  }
</script>

<template>
  <div class="flex h-full flex-col">
    <WButton type="ghost" class="body1-bold mb-4 flex items-center hover:underline" @click="onClose">
      <WidgetIcon :icon="themeIcons.chevronLeft" class="size-6"></WidgetIcon>
      <span>Find a Repair Location</span>
    </WButton>

    <div>
      <AddressSearch
        v-if="!loading"
        use-loqate
        :label="checkTheme('mercedes') ? 'Location' : checkTheme('toyota') ? 'Start by entering an address' : ''"
        :placeholder="checkTheme('mercedes') ? '' : 'Start by entering an address'"
        @place-changed="locationChange"
      />
      <div v-else class="h-10 animate-pulse rounded bg-gray-200"></div>
    </div>

    <div class="mt-4 flex-1 overflow-y-auto">
      <slot></slot>
    </div>
  </div>
</template>
